/**
 * Användarmanualen läser samma meny som sidomenyn.
 * En förfrågan, inga anrop per funktion.
 */

import { useEffect, useState } from 'react';
import { getUserMenu } from '@/services/systems/systemsService';
import type { MenuSystem } from '@/types/systems';

export function useUserMenu() {
  const [systems, setSystems] = useState<MenuSystem[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    getUserMenu()
      .then((menu) => {
        if (!cancelled) setSystems(menu.systems || []);
      })
      .catch(() => {
        if (!cancelled) setSystems([]);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return { systems, loading };
}
